import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class CategoryNameMappingService {
    public categoryNameMapping = {
        it: {
            "Distribution Centre": "Centri logistici",
            Gyms: "Gyms",
            "Head Office": "Head Office",
            "New Stores": "Nuovi store",
            Retail: "Retail",
        },
    };

    public getCategoryNames(locale: string) {
        return this.categoryNameMapping[locale] || {};
    }
}
